"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BETPortalObjectsApi = require("crm_ui/BET/engagementAssociations/api/BETPortalObjectsApi");

var _immutable = require("immutable");

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _LazyKeyStore = require("crm_data/store/LazyKeyStore");

var _makeBatch = _interopRequireDefault(require("crm_data/api/makeBatch"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var batchFetch = (0, _makeBatch.default)(function (id) {
  var objectType = id.get('objectType');
  var subjectId = id.get('subjectId');
  return (0, _BETPortalObjectsApi.fetch)(objectType, subjectId);
}, 'BETPortalObjectsStore.fetch');

var _makeKey = function _makeKey(subjectId, objectType) {
  return (0, _immutable.Map)({
    subjectId: subjectId,
    objectType: objectType
  });
};

(0, _LazyKeyStore.registerLazyKeyService)({
  namespace: _ActionNamespaces.BET_PORTAL_OBJECT_ASSOCIATIONS,
  fetch: batchFetch
});

var _default = (0, _LazyKeyStore.defineLazyKeyStore)({
  namespace: _ActionNamespaces.BET_PORTAL_OBJECT_ASSOCIATIONS,
  idIsValid: function idIsValid(key) {
    return _immutable.Map.isMap(key) && typeof key.get('subjectId') === 'number' && typeof key.get('objectType') === 'string';
  }
}).defineResponseTo(_ActionTypes.BET_PORTAL_OBJECT_ASSOCIATIONS_ADD, function (state, _ref) {
  var objectType = _ref.objectType,
      engagementId = _ref.engagementId,
      BETPortalAssociations = _ref.BETPortalAssociations;

  var key = _makeKey(engagementId, objectType);

  return state.update(key, function (associations) {
    if (!associations) {
      return associations;
    }

    return associations.concat(BETPortalAssociations);
  });
}).defineResponseTo(_ActionTypes.BET_PORTAL_OBJECT_ASSOCIATIONS_REMOVE, function (state, _ref2) {
  var objectType = _ref2.objectType,
      engagementId = _ref2.engagementId,
      BETPortalAssociation = _ref2.BETPortalAssociation;

  var key = _makeKey(engagementId, objectType);

  if (!state.get(key)) {
    return state;
  }

  return state.update(key, function (value) {
    return value.filterNot(function (portalAssociation) {
      return portalAssociation.equals(BETPortalAssociation);
    });
  });
}).register();

exports.default = _default;
module.exports = exports.default;